<template>
    <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">审核操作</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="auditState">
                        <el-radio-group v-model="ruleForm.auditState">
                            <el-radio label="1">通过</el-radio>
                            <el-radio label="-1">驳回</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="">原因</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="desc">
                        <el-input type="textarea" v-model="ruleForm.desc"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue } from '../../app.vues'

    export default {
        name: 'swb-asset-voucher-audit',
        desc: '业务单据通用审核',
        props: {},
        data: function () {
            return {
                ruleForm: {
                    auditState: '1'
                },
            }
        },
        created: function () {
        },
        methods: {
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = "info";
                result.data = self.ruleForm;
                return result;
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/compo/scrapVoucher/AssetVoucherAudit.vue